const FORMULA_TOKEN = /[ \t]*(?:(?<code>[A-Za-z_][A-Za-z0-9_]*)|(?<number>(?:0|[1-9][0-9]*)(?:\.[0-9]+)?|\.[0-9]+)|(?<op>[-+*/]))/y;

// Mirrors dotnet-api's EdiMappingWriteHelper.ValidateFormula, which is the real gate. The
// REPORTING.CALCULATE_ZA_CODE_VALUE UDF that dbt calls swaps each code in FORMULA_CODES for its value and runs the
// result through Python's eval, and a word that is not an exact ZA code (e.g. OF, whose ZA code is OF_) never makes
// it into FORMULA_CODES. Returns an error message, or null when the formula is valid.
export function validateZaFormula(formula: string, zaCode: string, zaCodes: string[]): string | null {
    if (formula === 'None') return null;

    const invalidExpression =
        `${zaCode}: "${formula.trim()}" is not a valid formula. Use ZA codes and numbers joined by + - * /.`;

    let expectOperand = true;
    let position = 0;
    FORMULA_TOKEN.lastIndex = 0;

    // A failed sticky exec resets lastIndex to 0, so the end of the last token is tracked separately.
    for (let match = FORMULA_TOKEN.exec(formula); match; match = FORMULA_TOKEN.exec(formula)) {
        position = FORMULA_TOKEN.lastIndex;
        const {code, number, op} = match.groups!;

        if (code !== undefined && !zaCodes.includes(code)) {
            const suggestion = zaCodes.includes(`${code}_`) ? ` Did you mean "${code}_"?` : '';
            return `${zaCode}: "${code}" is not a ZA code.${suggestion}`;
        }

        if (code !== undefined || number !== undefined) {
            if (!expectOperand) return invalidExpression;
            expectOperand = false;
        } else {
            const isUnarySign = expectOperand && (op === '+' || op === '-');
            if (expectOperand && !isUnarySign) return invalidExpression;
            expectOperand = true;
        }
    }

    const hasUnparsedText = formula.slice(position).replace(/^[ \t]+|[ \t]+$/g, '') !== '';
    return hasUnparsedText || expectOperand ? invalidExpression : null;
}
